import styled, { css } from 'styled-components';
import color from 'tinycolor2';
import { ModalActions, ModalContent } from 'components/Modal';

export const modalContentText = styled.p`
  font-size: 14px;
  color: ${(props) => color(props.theme['color.text.body'])};
`;

export const AugmentedModalActions = styled(ModalActions)`
  padding: 30px;
  display: grid;
  justify-content: flex-end;
  grid-gap: 16px;
  grid-auto-flow: column;
  position: relative;

  ${ModalContent} + & {
    padding-top: 0;
  }
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;

  &::before {
    content: '';
    position: absolute;
    top: -30px;
    right: 0;
    bottom: 0;
    left: 0;
    pointer-events: none;
    border-radius: 0 0 4px 4px;
  }
`;

const scrollbarStyle = css`
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar-track {
    background: none;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: ${(props) => color(props.theme['color.text.body']).setAlpha(0).toString()};
    border: 4px solid transparent;
    background-clip: padding-box;
  }

  &:hover::-webkit-scrollbar-thumb {
    background: ${(props) => color(props.theme['color.text.body']).setAlpha(0.2).toString()};
    border: 4px solid transparent;
    background-clip: padding-box;
  }

  &::-webkit-scrollbar {
    width: 18px;
    height: 14px;
  }

  ${(props) => props.hideScrollbar && `
    scrollbar-width: none;
    ::-webkit-scrollbar {
      width: 0px;
    }
  `}

`;

export const MainList = styled.ul`
  .active {
    background-color: rgba(0, 115, 202, 0.1);
    border-radius: 4px;
    margin-left: -10px;
    padding-left: 10px;
    display: flex;
    &:after {
      content: "\\2713";
      color: rgba(0, 0, 0, 0.4);
      margin-left: auto;
      margin-right: 5px;
      color: rgba(0, 115, 202, 1);
      font-size: 20px;
    }
  }
  max-height: 300px;
  overflow: scroll;
  overflow-x: hidden;
  margin-bottom: 60px;
  list-style-type: none;
  padding-inline-start: 10px;
  font-size: 16px;
  color: ${(props) => color(props.theme['color.text.body'])};
  font-weight: 600;
  line-height: 40px;
  ${scrollbarStyle}
  width: 110%;
`;

export const ListItem = styled.h1`
  display: flex;
  justify-content: center;
  align-items: center;
`;
